import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AuthService } from "../../services/auth.service";

@Component({
    selector: 'app-pg-complete-profile',
    templateUrl: './pg-complete-profile.component.html',
    styleUrls: ['./pg-complete-profile.component.scss'],
    standalone: false
})
export class PgCompleteProfileComponent implements OnInit {

    constructor(private authService:AuthService) { }

    @Input() forceShow:boolean

    @Output() onSave = new EventEmitter<void>()

    ngOnInit(): void {
    }

    getMode() {
        return this.authService.accessMode == 'business' ? 'business' : 'user'
    }

    isProfileIncomplete() {
        if(this.authService.isLoggedIn()) {
            if(this.authService.accessMode == 'business') return this.authService.isBusinessProfileIncomplete()
            else return this.authService.isUserProfileIncomplete()
        }
        else return false;
    }
}
